export default __webpack_public_path__ + "static/media/Emblem_Grandmaster.4c7dcfa9.webp";